import { render, staticRenderFns } from "./marketingTargetList.vue?vue&type=template&id=1e63c3ae&scoped=true"
import script from "./marketingTargetList.vue?vue&type=script&lang=js"
export * from "./marketingTargetList.vue?vue&type=script&lang=js"
import style0 from "./marketingTargetList.vue?vue&type=style&index=0&id=1e63c3ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e63c3ae",
  null
  
)

export default component.exports